import { render, staticRenderFns } from "./FormGoh.vue?vue&type=template&id=23e914ec&scoped=true"
import script from "./FormGoh.vue?vue&type=script&lang=js"
export * from "./FormGoh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e914ec",
  null
  
)

export default component.exports